// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-out';

export const Component = () => (
  <path d='M23.415 11.925a.434.434 0 0 1 .144.335c0 .144-.048.24-.144.335l-4.885 4.933c-.144.048-.24.096-.383.096-.335 0-.479-.144-.479-.479 0-.143.048-.239.144-.335l4.07-4.07H6.414c-.335 0-.526-.145-.526-.48 0-.335.191-.479.526-.479h15.47l-4.071-4.07a.434.434 0 0 1-.144-.336c0-.335.144-.527.479-.527.048 0 .191.048.383.144l4.885 4.933ZM14.22 18.63c-.336 0-.48.144-.48.48v3.927c0 .335-.143.479-.478.479H2.486c-.335 0-.527-.144-.527-.48V1.487c0-.336.192-.527.527-.527h10.776c.335 0 .479.191.479.526v3.927c0 .336.143.48.479.48.335 0 .526-.144.526-.48V1.485c0-.431-.144-.766-.431-1.054A1.408 1.408 0 0 0 13.26 0H2.485c-.431 0-.766.144-1.054.431A1.408 1.408 0 0 0 1 1.485v21.552c0 .431.144.766.431 1.054.288.287.623.43 1.054.43h10.776a1.41 1.41 0 0 0 1.054-.43c.287-.288.431-.623.431-1.054v-3.928c0-.335-.191-.479-.526-.479Z' />
);

export const viewBox = '0 0 25 25';
